import { createReactApp, window } from '@tarojs/runtime'
import component from "../node_modules/babel-loader/lib/index.js!./app.js"

import * as React from 'react'
import ReactDOM from 'react-dom'

var config = {"pages":["pages/index/index"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"WeChat","navigationBarTextStyle":"black"}};
window.__taroAppConfig = config
var inst = App(createReactApp(component, React, ReactDOM, config))

